import { http } from '../utils';
const URL_CHANGE_PASSWORD = 'api/Users/ChangePassWordComparePass';
export const changePassword = async (password) => {
    const is4ApiUrl = process.env.REACT_APP_AUTH_AUTHORITY_API;
    http.defaults.baseURL = is4ApiUrl;
    return await http.post(URL_CHANGE_PASSWORD, password);
};
